export const XFremenSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={(width / 96) * 102}
      viewBox="0 0 96 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_277_17"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="96"
        height="102"
      >
        <rect width="96" height="33" fill="#D9D9D9" />
        <rect x="1" y="71" width="95" height="31" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_277_17)">
        <circle
          cx="48.3556"
          cy="51.1112"
          r="50.6333"
          fill="url(#paint0_linear_277_17)"
          stroke="black"
        />
      </g>
      <line x1="2" y1="71.5" x2="95" y2="71.5" stroke="black" />
      <line x1="1" y1="32.5" x2="96" y2="32.5" stroke="black" />
      <circle
        cx="48.5"
        cy="51.5"
        r="21"
        fill="url(#paint1_linear_277_17)"
        stroke="black"
      />
      <line x1="48.5" y1="1.00011" x2="48.4787" y2="102" stroke="black" />
      <defs>
        <linearGradient
          id="paint0_linear_277_17"
          x1="48.3556"
          y1="0.977844"
          x2="48.3556"
          y2="101.245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1EFF0" />
          <stop offset="1" stopColor="#4EADEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_277_17"
          x1="48.5"
          y1="31"
          x2="48.5"
          y2="72"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AADCEF" />
          <stop offset="1" stopColor="#76C1ED" />
        </linearGradient>
      </defs>
    </svg>
  );
};
